<script>

import Chart from 'chart.js/auto'; // TODO!!! reduce this to what's actually needed
import autocolors from 'chartjs-plugin-autocolors';

Chart.register(autocolors);

export let game;
export let captain;
export let bot;
export let showScoreChange;
let chart;

let key = 'scoreAtStartOfTurn';
// deckSizeAtStartOfTurn
// activations

let chartElement;
let scoreDiff;

$: drawScoreChart(game, chartElement, showScoreChange, captain, bot);

function drawScoreChart(game, chartElement){
    if(chart) chart.destroy();
    if(!chartElement) return;
    if(!game) return;

    Chart.defaults.color = 'rgba(255, 255, 255, 0.8)';
    Chart.defaults.borderColor = 'rgba(255, 255, 255, 0.8)';

    let turnLabels = [];
    if(showScoreChange) turnLabels = [];

    let maxTurn = 0;

    let datasets = [];
    if(!Array.isArray(game)) game = [game];
    for(let g of game){
        for(let i = 1; i < g.turns; i++){
            if(maxTurn < i){
                maxTurn = i;
                turnLabels.push(`Turn ${i}`);
            }
        }
        for(let p of g.players){
            if(captain && (p.captain != captain || bot != 'all' && p.bot != bot)) continue;
            if(p.stats && p.stats.turns){
                //console.log(p.botLog);
                let data = [];
                
                for(let t of p.stats.turns){
                    if(t && t[key]) data.push(t[key]);
                }
                if(showScoreChange){
                    let lastScore = data[0];
                    let scoreDiff = [];
                    for(let t of data.slice(1)){
                        let diff = t - lastScore;
                        scoreDiff.push(diff);
                        lastScore = t;
                    }
                    data = scoreDiff;
                }
                datasets.push({
                    data,
                    label: p.captain,//g.players.map(p => p.captain).join(' v '),
                    color: 'rgba(0, 1, 0, 0)'
                });
            }
        }	
    }
    

    chart = new Chart(chartElement, {
        type: 'line',
        data: {
            labels: turnLabels,
            datasets
        },
        options: {
            plugins: {
                autocolors,
                legend: {
                    display: false
                },
            },
            interaction: {
                mode: 'nearest',
                intersect: false
            },
            /*onClick: (e) => {
                let elements = chart.getElementsAtEventForMode(e, 'nearest', { intersect: false }, true)
                if(elements.length === 0) return;
                let element = elements[0];
                let index = element.index;
                let datasetIndex = element.datasetIndex;
                if(game.players.length > element.datasetIndex){
                    let showTurn = false;
                    if(index > 0) showTurn = {turn: index, captain: game.players[datasetIndex]};
                    if(showScoreChange) showTurn.turn++;
                    logToDisplay = {log: game.players[0].log, players: game.players, showTurn}
                }
                //console.log(index, datasetIndex, relevantGames[datasetIndex])
            }*/
        }
    })
    

    //console.log(datasets);
}
</script>

<!--{#if game && showRow}
    <div class="modal">
        <LogText cards={logCards} players={game.players} log={game.players[0].log} {civs} {showRow} showCiv={civName} />
    <button on:click={e => {showRow = false} }>Close</button>
    </div>
{/if}


    {#if log.version}
        <div style="text-align: centre;">{log.version} version</div>
    {/if}
    {#if log.actions}
        <div style="text-align: centre;">{log.actions} total actions</div>
    {/if}
    {#if log.scoreByTurn}
        <div>
            Scores list (from turn '0' to game end): {log.scoreByTurn.join(', ')}
        </div>
    {/if}
    {#if scoreDiff}
        <div>
            Score change per turn: {scoreDiff.join(', ')}
        </div>
        <div>Chart:
            <div>
                <canvas bind:this={chartElement}></canvas>
            </div>
        </div>
    {/if}
    

 {#if scoreDiff}
    <div>
        Score change per turn: {scoreDiff.join(', ')}
    </div>
{/if}-->

<div>
    <div>
        <canvas bind:this={chartElement}></canvas>
    </div>
</div>
<style>

div {
    font-size: 2vmin;
}

</style>